import type { TopicsResponse } from "./types";
const keys = [
  "course",
  "lecture",
  "chapters",
  "topics",
  "types",
  "count",
  "mode",
  "primary",
  "set",
  "limit",
  "difficulty",
  "perPoint",
  "focus",
  "from",
  "primaryOnly",
  "planOnly",
];
export { filterCsv as csv } from "@shared/practiceFilters";
import { practiceFilters } from "@shared/practiceFilters";
export function invalidPracticeLink(params: URLSearchParams, taxonomy?: TopicsResponse): boolean {
  if (keys.some((key) => params.getAll(key).length > 1)) return true;
  if (params.has("course") && !params.has("lecture")) return true;
  if (params.has("lecture")) return keys.slice(2).some((key) => params.has(key));
  if (["limit", "difficulty", "focus", "primaryOnly", "planOnly"].some((key) => params.has(key)))
    return true;
  if (params.has("perPoint") && params.get("set") !== "timed-pair") return true;
  if (params.has("mode") && !["mixed", "topic"].includes(params.get("mode")!)) return true;
  if (!taxonomy) return false;
  const { chapters, topics, invalidTopics } = practiceFilters(params, taxonomy);
  return (
    invalidTopics ||
    topics.some((id) => {
      const topic = taxonomy.topics.find((t) => t.id === id);
      return !topic || (chapters.length > 0 && !chapters.includes(topic.chapter));
    })
  );
}
